import { render, staticRenderFns } from "./DataTableConfig.vue?vue&type=template&id=a0cc240c&scoped=true&"
import script from "./DataTableConfig.vue?vue&type=script&lang=js&"
export * from "./DataTableConfig.vue?vue&type=script&lang=js&"
import style0 from "./DataTableConfig.vue?vue&type=style&index=0&id=a0cc240c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cc240c",
  null
  
)

export default component.exports